import Facilities                       from "../../../domain/facility/Facilities";
import Facility                         from "../../../domain/facility/Facility";
import FacilityId                       from "../../../domain/facility/FacilityId";
import FacilityName                     from "../../../domain/facility/FacilityName";
import FacilityWebReservationTargetType from "../../../domain/facility/FacilityWebReservationTargetType";
import { ApiClient }                    from "../../configure/ApiClientConfig";
import { FacilitiesResponseType }       from "./FacilitiesResponseType";
import { FacilityResponseType }         from "./FacilityResponseType";

export const apiGetFacilities = async (): Promise<Facilities> => {
  const response = await ApiClient.get("/facilities");
  const data: FacilitiesResponseType = response.data;
  const list: Facility[] = data.facilities.map(facility => toFacility(facility));
  return new Facilities(list);
}

export const apiGetFacility = async (facilityId: FacilityId): Promise<Facility> => {
  const response = await ApiClient.get("/facility", {
    params: {
      id: facilityId.value,
    }
  });
  const data: FacilityResponseType = response.data;
  return toFacility(data);
}

export const apiPostFacility = async (facility: Facility): Promise<void> => await ApiClient.post("/facility/setting", {
  id: facility.id.value,
  name: facility.name.value,
  target_type: facility.targetType,
});

export const apiPutFacility = async (facility: Facility): Promise<void> => await ApiClient.put("/facility/setting", {
  id: facility.id.value,
  name: facility.name.value,
  target_type: facility.targetType,
});

export const apiDeleteFacility = async (facilityId: FacilityId): Promise<void> => await ApiClient.delete("/facility/setting", {
  params: {
    id: facilityId.value,
  }
});

export const apiPutFacilityTargetType = async (facilityId: FacilityId, targetType: FacilityWebReservationTargetType): Promise<void> => await ApiClient.put("/facility/setting/target", {
  id: facilityId.value,
  target_type: targetType,
});

const toFacility = (facility: FacilityResponseType): Facility => new Facility(
  new FacilityId(facility.id),
  new FacilityName(facility.name),
  toTargetType(facility.target_type),
);

const toTargetType = (target: string) => {
  switch (target) {
    default:
    case FacilityWebReservationTargetType.AVAILABLE:
      return FacilityWebReservationTargetType.AVAILABLE;
    case FacilityWebReservationTargetType.NOT_AVAILABLE:
      return FacilityWebReservationTargetType.NOT_AVAILABLE;
  }
}